import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Chapter } from "./shared";

const FAQS = [
  {
    q: "Is this window film or tinting?",
    a: "No. Film and tint sit on the glass as an adhesive layer and can bubble or peel at the edges over time. This is a liquid coating that bonds directly to the glass itself — nothing to peel, no film lines, no sticker look. It blocks 99.6% of infrared heat and 99% of UV, and lasts 10+ years.",
  },
  {
    q: "What happens at the free on-site demo?",
    a: "We come with two glass panels — one treated, one not — and a heat source. You feel the difference with your own hand and see the infrared readings yourself. About 20 minutes, no obligation, and we can measure up for a fixed written quote while we are there.",
  },
  {
    q: "How much does it cost?",
    a: "It depends on your glazed area, sun exposure, and access, so there is no honest price list. Every job gets a fixed written quotation, measured on your own glazing — free, and it doesn't change afterwards.",
  },
  {
    q: "How long does the coating last?",
    a: "The coating is engineered for a 10+ year lifespan in high-UV climates like Malta's, and every installation is covered by a 10-year warranty against peeling, cracking, and bubbling. It requires no special maintenance beyond normal glass cleaning.",
  },
  {
    q: "Will installation disrupt my business?",
    a: "No. The coating is applied directly to your existing glass in place. No removal, no replacement, no scaffolding in most cases. Rooms stay usable and your business stays open throughout.",
  },
  {
    q: "How long does application take?",
    a: "Most jobs are measured in hours, not days. A typical office floor or hotel corridor is completed within a day. We schedule around your trading hours, including early mornings and off-peak periods.",
  },
  {
    q: "Does it change how my glass looks?",
    a: "Yes, subtly. It gives glass a soft, even tint, which is exactly what kills the glare. Natural light and views stay. We show you a coated sample against your own windows before you commit to anything.",
  },
  {
    q: "Is it suitable for older or heritage buildings?",
    a: "Yes. Because nothing is replaced, it is ideal for buildings where the existing glazing cannot or should not be touched. We confirm suitability on site before any work is agreed.",
  },
];

export default function Faq() {
  const mid = Math.ceil(FAQS.length / 2);
  const columns = [FAQS.slice(0, mid), FAQS.slice(mid)];
  return (
    <section id="faq" data-testid="faq-section" className="pt-6 md:pt-8 pb-20 md:pb-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Chapter title="Questions" />
        <div className="mt-10 grid md:grid-cols-2 gap-6 md:gap-8 items-start">
          {columns.map((col, ci) => (
            <Reveal key={ci} delay={ci * 0.1}>
              <Accordion type="single" collapsible className="border border-slate-300 bg-white">
                {col.map((f, i) => {
                  const idx = ci * mid + i;
                  return (
                    <AccordionItem
                      key={idx}
                      value={`item-${idx}`}
                      className="border-slate-300 px-6 md:px-8"
                    >
                      <AccordionTrigger
                        data-testid={`faq-trigger-${idx}`}
                        className="font-heading font-bold text-left text-base md:text-lg text-slate-900 hover:text-[#0284C7] hover:no-underline py-6 transition-colors duration-150"
                      >
                        {f.q}
                      </AccordionTrigger>
                      <AccordionContent
                        data-testid={`faq-content-${idx}`}
                        className="text-sm md:text-base text-slate-600 leading-relaxed pb-6"
                      >
                        {f.a}
                      </AccordionContent>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
